import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSelectedCategoryPath } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCatalogPageStateByPath } from "@insite/client-framework/Store/Data/CatalogPages/CatalogPagesSelectors";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
// import ProductAddToListLink, {
//     ProductAddToListLinkStyles,
// } from "@insite/content-library/Components/ProductAddToListLink";
import CustomApplicationState from "@tLinc/Store/Data/CustomApplicationState/CustomApplicationState";

import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CustomProductAddToListLink, {
    ProductAddToListLinkStyles,
} from "@tLinc/Overrides/Components/CustomProductAddToListLink";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type OwnProps = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: CustomApplicationState) => {
    const location = getLocation(state);
    const pathnameLowerCase = location.pathname.toLowerCase();

    const selectedCategoryPath = getSelectedCategoryPath(state);

    const path =
        selectedCategoryPath ||
        (pathnameLowerCase.startsWith("/content/") || pathnameLowerCase.startsWith("/.spire/")
            ? ""
            : location.pathname);
    const catalogPage = getCatalogPageStateByPath(state, path).value;

    return {
        category: getCategoryState(state, catalogPage?.categoryIdWithBrandId ?? catalogPage?.categoryId).value,
        categoryWithHidePricing: state.LINCData.additionalSettingsReducer?.value?.categoryWithHidePricing,
        variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
    };
};

export interface ProductDetailsAddToListLinkStyles {
    wrapper?: InjectableCss;
    link?: ProductAddToListLinkStyles;
}

export const addToListLinkStyles: ProductDetailsAddToListLinkStyles = {
    wrapper: {
        css: css`
            margin-top: 10px;
            text-align: center;
        `,
    },
    link: {
        button: {
            css: css`
                width: 100%;
            `,
        },
    },
};

const styles = addToListLinkStyles;

const ProductDetailsAddToListLink: React.FC<OwnProps> = ({
    product,
    variantSelectionCompleted,
    category,
    categoryWithHidePricing,
}) => {
    if (!product.canAddToWishlist && !variantSelectionCompleted) {
        return null;
    }

    const showAddToListButton = !categoryWithHidePricing?.split(",").includes(category?.shortDescription);

    return showAddToListButton ? (
        <StyledWrapper {...styles.wrapper}>
            <CustomProductAddToListLink data-test-selector="productDetails_addToList" extendedStyles={styles.link} />
        </StyledWrapper>
    ) : null;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(ProductDetailsAddToListLink)),
    definition: {
        displayName: "Add to List Link",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
